import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("rmd_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${String(x.msg).replace(/^Value error, /, "")}`).join(" · ");
  return d.msg || String(d);
}

export const normPhone = (v) => {
  let d = String(v).replace(/\D/g, "");
  if (d.length > 10 && d.startsWith("91")) d = d.slice(2);
  if (d.length > 10 && d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 10);
};

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
const TZ = { timeZone: "Asia/Kolkata" };
export const fmtDay = (ymd) =>
  new Date(`${ymd}T00:00:00+05:30`).toLocaleDateString("en-IN", { ...TZ, weekday: "short", day: "numeric", month: "short", year: "numeric" });
export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString("en-IN", { ...TZ, day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
export const todayIST = () => new Date().toLocaleDateString("en-CA", TZ);

let actP;
export const getActivities = () =>
  (actP ||= api.get("/activities").then((r) => r.data).catch((e) => { actP = null; throw e; }));
export const getPublicSettings = () => api.get("/settings/public").then((r) => r.data);

export function calcPrice(rate, hours, s) {
  const r2 = (n) => Math.round(n * 100) / 100;
  const total = r2(rate * hours);
  const commission = r2((total * (s?.commission_rate ?? 30)) / 100);
  return { total, commission, companion_share: r2(total - commission), commission_rate: s?.commission_rate ?? 30 };
}
